import { mutations } from './mutations'
import { actions } from './actions'

export const pesquisa = {
  state: () => ({}),
  mutations: mutations,
  actions: actions
}



// WEBPACK FOOTER //
// ./src/store/modules/pesquisa_aulas/index.js